<ng-template #content_custom_fields_config let-offcanvas>
    <div class="{{localService.selectedLanguageCode}}"
        *ngIf="localService.languageContent && localService.languageContent.product_config">
        <div class="side_popup_header">
            <span>{{localService.languageContent.product_config.custom_fields}}</span>
            <button class="button_icon" (click)="onCloseTrigger()">close</button>
        </div>
        <div class="side_popup_body" style="margin: 10px;padding: 10px;height: calc(100vh - 130px);">
            <div class="row">
                <div class="col-4">
                    <button class="button_icon button_icon_color" (click)="onLoad()"
                        id="{{elementIds.btn_refresh}}">refresh</button>
                </div>
                <div class="col-8" style="text-align: right;">
                    <label style="font-weight: normal; margin-left: 15px;">
                        <input type="checkbox" [(ngModel)]="isShowDeleted" (change)="onLoad()" />
                        <span class="normal_color">{{localService.languageContent.product_config.show_deleted}}</span>
                    </label>
                </div>
            </div>
            <div class="banner" *ngFor="let item of items; index as idx">
                <div class="row">
                    <div class="col-3">
                        <button class="button_icon icon_adjust" (click)="onAction(2,item.key)"
                            id="{{elementIds.btn_delete + '_' + (idx+1)}}"
                            [disabled]="!(item.key && item.key.length > 5)"
                            [ngStyle]="{'color': item.v4 == '1' ? 'indianred' : 'green' }">
                            {{item.v4 == '1' ? "cancel" : "restore"}}
                        </button>
                        <span class="en">{{item.v3}}</span>
                    </div>
                    <div class="col-9">
                        <div>
                            <input autocomplete="off" type="text" style="margin-bottom: 10px;width: calc(100% - 40px);"
                                [(ngModel)]="item.v2" title="{{localService.languageContent.product_config.title}}"
                                id="{{elementIds.title + '_' + (idx+1)}}"
                                placeholder="{{localService.languageContent.product_config.title}}" />
                            <button class="button_icon button_icon_color icon_adjust" style="margin-left: 5px;"
                                (click)="onAction(1,item.key)" id="{{elementIds.btn_save + '_' + (idx+1)}}">
                                {{item.key && item.key.length > 5 ? 'save' : 'add_circle'}}
                            </button>
                        </div>
                    </div>
                </div>

                <div *ngIf="item.key && item.key.length > 5">
                    <app-label [Text]="localService.languageContent.product_config.display_at" />
                    <div *ngFor="let displayCustomFieldsItem of onGetDisplayForItems(item.key);">
                        <label style="font-weight: normal; margin-left: 35px;">
                            <input type="checkbox" [(ngModel)]="displayCustomFieldsItem.isSelected"
                                (change)="onAction(3,displayCustomFieldsItem.key,item.key)" />
                            <span class="normal_color">{{displayCustomFieldsItem.value}}</span>
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>